
import { ReactElement } from 'react';
export interface Action { function?: (rowObject: any) => void; }
export interface ActionIcon extends Action { icon: string | ReactElement | ((rowObject: any) => ReactElement | null); }
export interface ActionText extends Action { text: string; }
export type ColumnType = 'text' | 'number' | 'percentage' | 'currency' | 'currency-type' | 'date' | 'action' | 'boolean' | 'status' | 'checkbox';

// tipos de filtro (simple)
export type FilterKind = 'string' | 'number' | 'select' | 'boolean' | 'image';

export interface ColumnDefinition {
  key: string;
  type?: ColumnType;
  label?: string; 
  header?: boolean; // Usado en modo LIST/accordion
  action?: ActionIcon | ActionText;
  mapValue?: (rowObject: any) => string | ReactElement;
  fixedWidth?: number; 
  percentageWidth?: number; 
  hidden?: boolean; 
  beforePrint?: (rowObject: any, columnDefinition: ColumnDefinition) => void;
  // Agrupación opcional (SideModal)
  category?: string;
  // Ordenamiento opt-in
  sortable?: boolean;
  sortAccessor?: (rowObject: any) => number | string | Date;
  // metadatos de filtro por columna (QuickFilter)
  filterKind?: FilterKind; // 'string' | 'number' | 'select' | 'boolean'
}

export interface CurrencyColumnDefinition extends ColumnDefinition { currency: number; }
export interface ReferenceKeyColumnDefinition extends ColumnDefinition { columnDefinitionKey: string; }
export interface CheckColumnDefinition extends ColumnDefinition { selectedOptions: number[]; }
function columnDefinition(props: ColumnDefinition) { return props; }
export function textColumnDefinition(props: ColumnDefinition) { return columnDefinition({ ...props, type: 'text' }); }
export function numericColumnDefinition(props: ColumnDefinition) { return columnDefinition({ ...props, type: 'number' }); }
export function booleanColumnDefinition(props: ColumnDefinition) { return columnDefinition({ ...props, type: 'boolean' }); }
export function statusColumnDefinition(props: ColumnDefinition) { return columnDefinition({ ...props, type: 'status' }); }
export function percentageColumnDefinition(props: ColumnDefinition) { return columnDefinition({ ...props, type: 'percentage' }); }
export function currencyColumnDefinition(props: CurrencyColumnDefinition | ReferenceKeyColumnDefinition) { return columnDefinition({ ...props, type: 'currency' }); }
export function currencyTypeColumnDefinition(props: ColumnDefinition) { return columnDefinition({ ...props, type: 'currency-type' }); }
export function dateColumnDefinition(props: ColumnDefinition) { return columnDefinition({ ...props, type: 'date' }); }
export function actionColumnDefinition(props: ColumnDefinition) { return columnDefinition({ ...props, type: 'action' }); }
export function checkColumnDefinition(props: ColumnDefinition) { return columnDefinition({ ...props, type: 'checkbox' }); }
export function isBooleanColumnDefinition(props: ColumnDefinition): boolean { return props.type === 'boolean'; }
export function isStatusColumnDefinition(props: ColumnDefinition): boolean { return props.type === 'status'; }
export function isTextColumnDefinition(props: ColumnDefinition): boolean { return props.type === 'text'; }
export function isNumericColumnDefinition(props: ColumnDefinition): boolean { return props.type === 'number'; }
export function isPercentageColumnDefinition(props: ColumnDefinition): boolean { return props.type === 'percentage'; }
export function isCurrencyColumnDefinition(props: ColumnDefinition): boolean { return props.type === 'currency'; }
export function isCurrencyTypeColumnDefinition(props: ColumnDefinition): boolean { return props.type === 'currency-type'; }
export function isDateColumnDefinition(props: ColumnDefinition): boolean { return props.type === 'date'; }
export function isActionColumnDefinition(props: ColumnDefinition): boolean { return props.type === 'action'; }
export function isCheckColumnDefinition(props: ColumnDefinition): boolean { return props.type === 'checkbox'; }
